export class CacheService {
  private static CACHE_DURATION = 24 * 60 * 60 * 1000;

  static setCache(key: string, data: any): void {
    const cacheItem = {
      data,
      timestamp: Date.now(),
      lastUpdate: new Date().toLocaleString('pt-BR')
    };
    localStorage.setItem(key, JSON.stringify(cacheItem));
  }

  static getCache(key: string, forceExpiring: boolean): any | null {
    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const cacheItem = JSON.parse(cached);
    const isExpired = Date.now() - cacheItem.timestamp > this.CACHE_DURATION;

    if (isExpired || forceExpiring) {
      localStorage.removeItem(key);
      return null;
    }

    return {
      data: cacheItem.data,
      lastUpdate: cacheItem.lastUpdate
    };
  }

  static getLastUpdateDate(key: string): string | null {
    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const cacheItem = JSON.parse(cached);
    return cacheItem.lastUpdate;
  }

  static clearCache(key?: string): void {
    if (key) {
      localStorage.removeItem(key);
    } else {
      localStorage.clear();
    }
  }
}
